import { Stack } from '@mui/material'
import { formatPaymentPlanInterest } from '@src/services/Formatter'
import { MerchantPaymentPlan } from '../../../data/types/MerchantPaymentPlan'

interface Props {
  merchantPaymentPlan: MerchantPaymentPlan
}

const FormattedMerchantPaymentPlan = ({ merchantPaymentPlan }: Props) => {

  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      <span>{formatPaymentPlanInterest(merchantPaymentPlan)}</span>
    </Stack>
  )
}

export default FormattedMerchantPaymentPlan
